export type NavItem = {
  label: string;
  href: string;
  description?: string;
  sectionId?: string;
};

export const WHITEPAPER_URL = "";

export const navGroups: Array<{ label: string; items: NavItem[] }> = [
  {
    label: "Product",
    items: [
      {
        label: "Agent Trust Gateway",
        href: "/gateway",
        description: "The control layer for autonomous execution.",
      },
      {
        label: "Delegated Action Control",
        href: "/delegated-action-control",
        description: "Bounded authority for autonomous agents.",
      },
      {
        label: "Policy Engine",
        href: "/gateway#policy-engine",
        description: "Real-time policy enforcement.",
      },
      {
        label: "Action Receipts",
        href: "/action-receipts",
        description:
          "Cryptographic proofs and inspectable records of agent actions.",
      },
    ],
  },
  {
    label: "Protocol",
    items: [
      { label: "Protocol Overview", href: "/protocol" },
      { label: "Architecture", href: "/protocol#architecture" },
      { label: "Identity & Intent", href: "/protocol#identity-intent" },
      { label: "Delegated Authority", href: "/delegated-action-control" },
      { label: "Verification & Accountability", href: "/action-receipts" },
      { label: "Security", href: "/security" },
    ],
  },
  {
    label: "Network",
    items: [
      { label: "ORIQ Network", href: "/network" },
      { label: "Verifiers", href: "/network#verifiers" },
      { label: "Validators", href: "/network#validators" },
    ],
  },
  {
    label: "Developers",
    items: [
      { label: "Documentation", href: "/developers" },
      { label: "Quickstart", href: "/developers" },
      { label: "MCP Integration", href: "/developers" },
      { label: "SDK", href: "/developers" },
    ],
  },
  {
    label: "Resources",
    items: [
      { label: "Whitepaper", href: "/whitepaper" },
      { label: "Roadmap", href: "/roadmap" },
      { label: "Research", href: "/developers" },
    ],
  },
];

export const whitepaperChapters = [
  "Abstract",
  "Autonomous Agent Problem",
  "ORIQ Thesis",
  "Protocol Overview",
  "Agent Trust Model",
  "Delegated Action Protocol",
  "Architecture",
  "Policy & Permission Engine",
  "Identity & Intent",
  "Verification & Accountability",
  "Cryptographic & On-chain Layer",
  "ORIQ Network",
  "Economic Model",
  "Token Model",
  "Security & Threat Model",
  "Governance",
  "Roadmap",
  "Conclusion",
];

export const footerGroups: Array<{ label: string; items: NavItem[] }> = [
  {
    label: "Product",
    items: navGroups[0].items.filter((item) => item.label !== "Policy Engine"),
  },
  {
    label: "Protocol",
    items: [
      { label: "Overview", href: "/protocol" },
      { label: "Architecture", href: "/protocol#architecture" },
      { label: "Network", href: "/network" },
      { label: "Security", href: "/security" },
    ],
  },
  {
    label: "Developers",
    items: [
      { label: "Documentation", href: "/developers" },
      { label: "Quickstart", href: "/developers" },
      { label: "MCP Integration", href: "/developers" },
      { label: "SDK", href: "/developers" },
    ],
  },
  {
    label: "Resources",
    items: [
      { label: "Whitepaper", href: "/whitepaper" },
      { label: "Roadmap", href: "/roadmap" },
      { label: "Research", href: "/developers" },
    ],
  },
];

export const riskTags = [
  "PROMPT INJECTION",
  "EXCESSIVE AGENCY",
  "INTENT DRIFT",
  "CREDENTIAL EXPOSURE",
  "UNAUTHORIZED ACTION",
  "ACCOUNTABILITY GAP",
];

export const capabilityFields = [
  ["Agent", "Procurement Agent"],
  ["Intent", "Acquire Compute"],
  ["Action", "Purchase"],
  ["Resource", "Compute"],
  ["Provider", "Approved Providers"],
  ["Amount", "Bounded"],
  ["Duration", "Session Limited"],
  ["Delegation", "Restricted"],
  ["Status", "ACTIVE"],
];

export const receiptFields = [
  ["STATUS", "VERIFIED"],
  ["AGENT", "Agent ID"],
  ["INTENT", "Intent Hash"],
  ["AUTHORITY", "VALID"],
  ["CAPABILITY", "VALID"],
  ["ACTION", "EXECUTED"],
  ["OUTCOME", "VERIFIED"],
  ["RECEIPT", "Receipt Hash"],
];
